import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ImpressumPage } from './pages/ImpressumPage';
import { DatenschutzPage } from './pages/DatenschutzPage';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { AboutPage } from './pages/AboutPage';
import { KostenloseDemoPage } from './pages/KostenloseDemoPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { SitemapPage } from './pages/SitemapPage';
import { RobotsPage } from './pages/RobotsPage';
import { ScrollToTop } from './components/ScrollToTop';
import { LanguageProvider } from './contexts/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/blog" element={<BlogPage data-id="element-7" />} data-id="element-6" />
          <Route path="/blog/:slug" element={<BlogPostPage data-id="element-9" />} data-id="element-8" />
          <Route path="/impressum" element={<ImpressumPage data-id="element-11" />} data-id="element-10" />
          <Route path="/datenschutz" element={<DatenschutzPage data-id="element-13" />} data-id="element-12" />
          <Route path="/about" element={<AboutPage data-id="element-15" />} data-id="element-14" />
          <Route path="/kostenlose-demo" element={<KostenloseDemoPage data-id="element-17" />} data-id="element-16" />
          <Route path="/sitemap.xml" element={<SitemapPage data-id="element-19" />} data-id="element-18" />
          <Route path="/robots.txt" element={<RobotsPage data-id="element-21" />} data-id="element-20" />
          <Route path="*" element={<NotFoundPage data-id="element-23" />} data-id="element-22" />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>;
}